import React, { FC } from 'react';
import Modal from '~ComponentsImproved/Modal';
import { ModalContent } from '~Styles/modal';
import useModal from '~ComponentsImproved/Modal/useModal';
import { useButton, useI18n } from '~Hooks';
import styled from '@emotion/styled';
import { GetCompetitions_Venue_competitions } from '~Providers/CompetitionsProvider/__queries__';
import {
  GetStaffAndCategories_user_company_staffs,
  GetStaffAndCategories_user_company_categories,
  GetItems_items_results,
} from '../../__queries__';
import { Button } from '~Styles';
import { getCompetitionDateStatus } from '~Providers/CompetitionsProvider/utils';
import LeaderboardContent from './LeaderboardContent';

const ViewLeaderboardButtonWrapper = styled(Button)`
  background-color: var(--colorBlueGray1000);
  color: #fff;
  width: 100%;
`;

interface Props {
  competition: GetCompetitions_Venue_competitions;
  staffs: GetStaffAndCategories_user_company_staffs[];
  categories: GetStaffAndCategories_user_company_categories[];
  items: GetItems_items_results[];
}

const ViewLeaderboard: FC<Props> = ({ competition, staffs, categories, items }) => {
  const { i18n } = useI18n();
  const modal = useModal();

  const viewLeaderboardButton = useButton({
    onClick: () => modal.show(),
  });

  const compStatus = getCompetitionDateStatus(competition.startDate, competition.endDate);

  return (
    <>
      <ViewLeaderboardButtonWrapper {...viewLeaderboardButton}>
        {compStatus.isUpcoming
          ? i18n('Competitions.ViewInfo')
          : i18n('Competitions.ViewLeaderboard')}
      </ViewLeaderboardButtonWrapper>
      <Modal isShowing={modal.isShowing} hide={() => modal.hide()}>
        <ModalContent>
          <LeaderboardContent
            competition={competition}
            staffs={staffs}
            categories={categories}
            items={items}
          />
        </ModalContent>
      </Modal>
    </>
  );
};

export default ViewLeaderboard;
